import {
  GET_MEASURE_ENGAGEMENT_WATCHER,
  GET_MEASURE_ENGAGEMENT_SUCCESS,
  GET_MEASURE_ENGAGEMENT_FAILED,
  GET_DIMENSIONS_DATA_WATCHER,
  GET_DIMENSIONS_DATA_SUCCESS,
  GET_DIMENSIONS_DATA_FAILED,
} from "./constants"

export function getMeasureEngagementWatcher(payload) {
  return { type: GET_MEASURE_ENGAGEMENT_WATCHER, payload }
}

export function getMeasureEngagementSuccess(payload) {
  return { type: GET_MEASURE_ENGAGEMENT_SUCCESS, payload }
}

export function getMeasureEngagementFailed() {
  return { type: GET_MEASURE_ENGAGEMENT_FAILED }
}

export function getDimensionsDataWatcher(payload) {
  return { type: GET_DIMENSIONS_DATA_WATCHER, payload }
}

export function getDimensionsDataSuccess(payload) {
  return { type: GET_DIMENSIONS_DATA_SUCCESS, payload }
}

export function getDimensionsDataFailed() {
  return { type: GET_DIMENSIONS_DATA_FAILED }
}
